import OrbitApiV1 from '.'

class IccidAPI {
  static async getIccid(limit) {
    return OrbitApiV1.httpGet(`/iccid?limit=${limit}`)
  }
}

export default IccidAPI
